import React, { useState, useEffect } from "react";
import {
  submitActivity,
  getMaquinarias,
  procesoByMaquinaria,
  materialesByProceso,
  submitActivityClose,
  submitActivityPeso,
  submitActivityClosePeso,
} from "../services/activityService";
import {
  showSuccessAlert,
  showErrorAlert,
} from "../services/alertService";
import "./FormStyles.css";

const ActivityForm = () => {
  const [number, setNumber] = useState(null);
  const [sipeso, setSipeso] = useState(false);
  const [sipeso1, setSipeso1] = useState(false);
  const [select1, setSelect1] = useState([]);
  const [select2, setSelect2] = useState([]);
  const [select3, setSelect3] = useState([]);
  const [option1, setOption1] = useState(null);
  const [option2, setOption2] = useState(null);
  const [option3, setOption3] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [textInput, setTextInput] = useState(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const options1 = await getMaquinarias();
        setSelect1(options1);
      } catch (error) {
        showErrorAlert("Failed to fetch maquinarias");
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    setOption2(null);
    setOption3(null);
    setSelect2([]);
    setSelect3([]);
  }, [option1]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const options2 = await procesoByMaquinaria(option1);
        setOption3(null);
        setSelect2(options2);
      } catch (error) {
        showErrorAlert("Failed to fetch procesos");
      }
    };
    if (option1) {
      fetchOptions();
    }
  }, [option1]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const options3 = await materialesByProceso(option2, option1);
        setOption3(null);
        setSelect3(options3);
      } catch (error) {
        showErrorAlert("Failed to fetch Materiales");
      }
    };
    if (option2) {
      fetchOptions();
    }
  }, [option2]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!number || !option1 || !option2 || !option3) {
      showErrorAlert("Por favor complete todos los campos.");
      return;
    }
    const data = {
      codigoColaborador: number.toUpperCase(),
      maquinariaId: option1,
      procesoId: option2,
      materialId: option3,
      peso: null,
    };
    if (sipeso) {
      submitActivityPeso(data).then((response) => {
        if (response) {
          showSuccessAlert("La actividad se ha registrado correctamente.");
        }
        setNumber("");
        setOption1("");
        setOption2(null);
        setOption3(null);
        setSipeso(false);
      });
    }else{
      submitActivity(data)
      .then((response) => {
        if (response) {
          showSuccessAlert("La actividad se ha registrado correctamente.");
        }
        setNumber("");
        setOption1("");
        setOption2(null);
        setOption3(null);
        setSipeso(false);
      })
      .catch((error) => {
        showErrorAlert("Fallo o No existe el código.");
        console.error("Failed to submit activity", error);
      });
    }
  };

  const handleTextInputSubmit = (e) => {
    e.preventDefault();
    if (!textInput) {
      showErrorAlert("Por favor ingrese el código.");
      return;
    }
    const data = {
      codigoColaborador: textInput.toUpperCase(),
    };

    if (sipeso1){
      submitActivityClosePeso(data).then((response) => {
        if (response) {
          showSuccessAlert("Las actividades se han cerrado correctamente.");
        } else {
          showErrorAlert("Error al cerrar actividades.");
        }
        setTextInput('');
        setSipeso1(false);
      }).catch((error) => {
        showErrorAlert("Failed o No registra actividades");
        console.error("Failed to close activities", error);
      });
    }else{
      submitActivityClose(data).then((response) => {
        if (response) {
          showSuccessAlert("Las actividades se han cerrado correctamente.");
        } else {
          showErrorAlert("Error al cerrar actividades.");
        }
        setTextInput('');
        setSipeso1(false);
      }).catch((error) => {
        showErrorAlert("Failed o No registra actividades");
        console.error("Failed to close activities", error);
      });
    }
  };

  return (
    <div className="form-container">
      <div className="row">
        <div className="col-md-12 mb-4">
        <h5>{currentDateTime.toLocaleString()}</h5>
        </div>
        <div className="col-md-6 mb-4">
          <form onSubmit={handleSubmit} className="form-content">
            <h4>Registro de Actividad</h4>
            <div className="mb-3">
              <label htmlFor="numberInput" className="form-label">
                Código
              </label>
              <input
                type="text"
                className="form-control"
                id="numberInput"
                maxLength="5"
                value={number}
                onChange={(e) => setNumber(e.target.value.toUpperCase())}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="select1" className="form-label">
                Maquinaria
              </label>
              <select
                className="form-select"
                id="select1"
                value={option1}
                onChange={(e) => setOption1(e.target.value)}
              >
                <option value="">Seleccione una maquinaria</option>
                {select1.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="select2" className="form-label">
                Proceso
              </label>
              <select
                className="form-select"
                id="select2"
                value={option2}
                onChange={(e) => setOption2(e.target.value)}
              >
                <option value="">Seleccione un proceso</option>
                {select2.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="select3" className="form-label">
                Material
              </label>
              <select
                className="form-select"
                id="select3"
                value={option3}
                onChange={(e) => setOption3(e.target.value)}
              >
                <option value="">Seleccione un material</option>
                {select3.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="m-3">
              <input
                className="form-check-input large-checkbox"
                checked={sipeso}
                onChange={(e) => setSipeso(e.target.checked)}
                type="checkbox"
                id="sipeso"
              />
              <label className="form-check-label" for="defaultCheck1">
                Si el material tiene peso, marcar esta casilla
              </label>
            </div>
            <button type="submit" className="btn btn-success btn-lg w-100">
              Registrar Actividad
            </button>
          </form>
        </div>
        <div className="col-md-6 mb-4">
          <form onSubmit={handleTextInputSubmit} className="form-content">
          <h4>Salidas</h4>
            <div className="mb-3">
              <label htmlFor="textInput" className="form-label">
                Código del Colaborador
              </label>
              <input
                type="text"
                className="form-control"
                id="textInput"
                maxLength="5"
                value={textInput}
                onChange={(e) => setTextInput(e.target.value.toUpperCase())}
              />
            </div>
            <div className="m-3">
              <input
                className="form-check-input large-checkbox"
                checked={sipeso1}
                onChange={(e) => setSipeso1(e.target.checked)}
                type="checkbox"
                id="sipeso1"
              />
              <label className="form-check-label" for="defaultCheck1">
                Si el material tiene peso, marcar esta casilla
              </label>
            </div>
            <button type="submit" className="btn btn-warning btn-lg w-100">
              Cerrar Todas las Actividades
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ActivityForm;
